import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API_FORMDATA = Axios.getInstanceForFormData
const API = Axios.getInstance

export const addOrgRegulation = (data, orgId, loginId) => {
    const istOffset = 5.5 * 60 * 60 * 1000
    data.expiryDate = data.expiryDate ? new Date(data.expiryDate.getTime() + istOffset) : null
    const params = { orgId, loginId }
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.ADD_ORG_REGULATION, { orgRegulationRequests: [data] }, { params })
        .then(response => response)
        .catch(err => err)
}
export const getAllRegulations = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_REGULATIONS)
        .then(response => response)
        .catch(err => err)
}

export const getAllRegulationsBasedType = (typeId) => {
    const params = { typeId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_REGULATIONS_TYPE, { params })
        .then(response => response)
        .catch(err => err)
}

export const getSelectedRegulations = (orgId, typeId) => {
    const params = { orgId, typeId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_SELECTED_REGULATIONS, { params })
        .then(response => response)
        .catch(err => err)
}

export const selectOrgRegulation = (data, orgId, loginId) => {
    const params = { orgId, loginId }
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.SELECT_ORG_REGULATION, { selectedRegulationRequest: data }, { params })
        .then(response => response)
        .catch(err => err)
}
export const getDepOrg = (organizationId) => {
    const params = { organizationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_DEP_ORGANIZATION, { params })
        .then(response => response)
        .catch(err => err)
}
export const getRolebyDep = (departmentId) => {
    const params = { departmentId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ROLES_BY_DEP, { params })
        .then(response => response)
        .catch(err => err)
}
export const getUserByRole = (roleId, orgId, deptId) => {
    const params = { roleId, orgId, deptId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_USER_BY_ROLES, { params })
        .then(response => response)
        .catch(err => err)
}
export const getManagementTeam = (orgId) => {
    const params = { orgId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_MANAGEMENT_TEAM, { params })
        .then(response => response)
        .catch(err => err)
}
